import { render, staticRenderFns } from "./AppPanel.vue?vue&type=template&id=35650313&scoped=true&"
import script from "./AppPanel.vue?vue&type=script&lang=js&"
export * from "./AppPanel.vue?vue&type=script&lang=js&"
import style0 from "./AppPanel.vue?vue&type=style&index=0&id=35650313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35650313",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35650313')) {
      api.createRecord('35650313', component.options)
    } else {
      api.reload('35650313', component.options)
    }
    module.hot.accept("./AppPanel.vue?vue&type=template&id=35650313&scoped=true&", function () {
      api.rerender('35650313', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppPanel.vue"
export default component.exports